import svg4everybody from 'svg4everybody';

if (!window.site) window.site = {};

function getCountDownTime (timer){
  // Time calculations for days, hours, minutes and seconds
  const days = Math.floor(timer / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timer % (1000 * 60)) / 1000);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const d = new Date(Date.now() + timer);
  if (days >= 1) return `available on ${monthNames[d.getMonth()]} ${d.getDay()}`;

  return `available in ${hours < 10 ? 0 : ''}${hours}:${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
}



// One time after page loading
window.site.initPage = function () {
  document.querySelectorAll('.review__rating').forEach(ratingBlock => {
    for (let i =0;i<ratingBlock.dataset.size;i++){
      const newStar = document.createElement('div');
      newStar.className = "review__rating-item";
      ratingBlock.append(newStar);
    }
  })
  if (document.querySelector('.splide')){
    const splide = new window.splide( '.splide', {
      type: 'loop',
      autoWidth: true,
      autoHeight: true,
      pagination: true,
      focus: 'center',
      perMove: 1,
      updateOnMove: true,
      arrows: true,
    });
    splide.on( 'active', function (slideItem) {
      if (!slideItem.slide.classList.contains('splide__slide--clone')){
        const cards = slideItem.slide.closest('.splide__list').querySelectorAll('.cyber-card');
        cards.forEach(cardItem => {
          cardItem.classList.remove('cyber-card_clipped')
          cardItem.classList.add('cyber-card--blur')
        });

        const card = slideItem.slide.querySelector('.cyber-card');
        card.classList.remove('cyber-card--blur');
        card.classList.add('cyber-card_clipped');

      }
    });
    splide.mount();
  }

/*  document.querySelectorAll('.giveaway-item').forEach(giveAwayItem => {
    const numberElement = giveAwayItem.querySelector('.giveaway-item__number');
    const number = parseInt(numberElement?.dataset.index) + 1;
    if (number > 0) {
      numberElement.innerText = `${numberElement.innerText} ${number}`;
    }
    const unlock = giveAwayItem.querySelector('.giveaway-item__status');
    if (unlock?.dataset.startdate) {
      const curDate = new Date;
      const unlockDate = new Date(unlock.dataset.startdate);
      if (curDate.getTime() - unlockDate.getTime() > 0) {
        giveAwayItem.classList.remove('giveaway-item_locked')
        unlock.innerHTML = 'UNLOCKED';
      }
      else {
        const counter = giveAwayItem.querySelector('.giveaway-item__available-on');
        const button = giveAwayItem.querySelector('.button__content').innerHTML = 'Notify Me'
        setInterval(() => {
          counter.innerHTML = getCountDownTime( unlockDate.getTime() - Date.now())
        }, 1000);
      }
    }
  })
  const unlockedItems = document.querySelectorAll('.giveaway-item:not(.giveaway-item_locked)');
  const current = unlockedItems[unlockedItems.length - 1];
  if (current){
    current.classList.add('giveaway-item_current');
    current.closest('.cyber-card').classList.add('cyber-card_clipped');
    current.closest('.cyber-card').classList.add('cyber-card_transformed');
    current.closest('.cyber-card').classList.remove('cyber-card--blur');

  }  */
};

// Every time after creating new elements. For example: after ajax loading
window.site.initElements = function () {
  svg4everybody();
};

window.addEventListener('load', () => {
  window.site.initPage();
  window.site.initElements();
});